var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEffect3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99834 0.798321C7.09864 0.525356 7.4847 0.525357 7.58499 0.798322L8.75237 3.97547C9.06865 4.83626 9.74707 5.51468 10.6079 5.83096L13.785 6.99834C14.058 7.09864 14.058 7.4847 13.785 7.58499L10.6079 8.75237C9.74707 9.06865 9.06865 9.74707 8.75237 10.6079L7.58499 13.785C7.4847 14.058 7.09863 14.058 6.99834 13.785L5.83096 10.6079C5.51468 9.74707 4.83626 9.06865 3.97547 8.75237L0.798321 7.58499C0.525356 7.4847 0.525357 7.09863 0.798322 6.99834L3.97547 5.83096C4.83626 5.51468 5.51468 4.83626 5.83096 3.97547L6.99834 0.798321Z",
    fill: "url(#paint0_linear_2053_31059)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2053_31059",
    x1: -0.303819,
    y1: 13.6995,
    x2: 15.4604,
    y2: 12.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C5ADE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9796F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffect3);
export default __webpack_public_path__ + "static/media/effect3.ab931e5fa6c63f093b536ec505ca9f0d.svg";
export { ForwardRef as ReactComponent };